import { Parent } from './parent';

export interface Child<T> {
  parent: T;
}
